import React, { Component } from "react";

class V1Home extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <React.Fragment>
                <main>
                    <div className="col text-center">
                        <h3 className="display-6 fw-normal">
                            Version 1.0 - Assessment Academy Report Tool
                        </h3>
                    </div>
                    <div>

                    </div>
                </main>
            </React.Fragment>
        )
    }
}

export default V1Home;